<template>
  <div class="detail-content" style="overflow:auto;height:100%;width:100%;font-size: 0;">
    <iframe id="liveFrame"
            name="liveFrame"
            style="width:100%;height:100%;"
            allow="fullscreen;camera;microphone"
            class="archArch-box"
            :src="`https://openvidu.520emv.com/#/${$store.state.userInfo.userId}/live/audience?userNickName=${getRandomString()}`"
            frameborder="0"></iframe>
  </div>
</template>
<script>
export default{
  name:'liveShow',
  methods:{
    //获取随机字符
    getRandomString () {
      return Math.random().toString(36).slice(-8);
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/flowDetail/liveShow.vue